import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Link, Text } from '@chakra-ui/react';

import { useAppSelector } from '../../../store/hooks';
import { RootState } from '../../../store/types';
import textContent from '../../../utils/textContent.json';
import Button from '../Button/Button';

const CustomerButton = () => {
  const { isOpen } = useAppSelector((state: RootState) => state.sideMenuIsOpen);
  const [showPopup, setShowPopup] = useState(true);

  // Obtener el query string de la URL
  const query = window.location.search;
  // Si la URL contiene "?centro", se usa el número 5493525521008; para "?norte" o sin query se usa el número 5493525521001
  const whatsappNumber = query === '?centro' ? '5493525521008' : '5493525521001';

  if (!showPopup) return null;

  return (
    <Flex
      position={!isOpen ? 'fixed' : 'initial'}
      bottom={!isOpen ? '20px' : ''}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      fontStyle="normal"
      fontWeight="500"
      lineHeight="normal"
      color="darkBlue"
      minHeight="110px"
      width="80%"
      boxShadow="0px 1.62145px 3.2429px 0px rgba(0, 17, 51, 0.15)"
      backgroundColor="var(--tonos-y-matices-white-white-50, #FFF)"
      padding="10px 0"
      border="0.811px solid #E2E8F0"
      borderRadius="6.486px"
      data-testid="customer-button-container"
    >
      {/* Botón de cierre */}
      <Box
        position="absolute"
        top="5px"
        right="10px"
        fontSize="20px"
        cursor="pointer"
        onClick={() => setShowPopup(false)}
      >
        &times;
      </Box>
      <Text fontSize="16px" data-testid="title-customer-button" textAlign="center" padding="10px">
        {textContent.customerButton.title}
      </Text>
      <Text
        fontSize="12px"
        margin="0 0 16px 0"
        data-testid="sub-title-customer-button"
        textAlign="center"
        fontWeight="300"
        padding="0 10px"
      >
        {!isOpen ? textContent.customerButton.subTitle : ''}
      </Text>
      <Link as={RouterLink} to="/register">
        <Button
          color="white"
          backgroundColor="purple"
          fontSize="16px"
          _hover={{ backgroundColor: 'darkPurple' }}
          data-testid="customer-button"
        >
          {textContent.customerButton.customerButtonText}
        </Button>
      </Link>
    </Flex>
  );
};

export default CustomerButton;
